// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"548":"312d10ab","770":"af69441c","856":"23116594"}[chunkId] + ".chunk.js");